export default "__VITE_ASSET__7b1e37b8__"